export interface  NamespaceParamModel {
  id: string;
  key: string;
  type: NamespaceParamTypes;
  description: string;
  hint?: string;
  mandatory?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export enum NamespaceParamTypes {
  VAT = 'VAT',
  STRING = 'STRING',
  YEAR = 'YEAR',
  URL = 'URL',
  DATE = 'DATE',
}

export const namespaceParamTypeLabels = new Map<NamespaceParamTypes | string, string>()
  .set(NamespaceParamTypes.VAT, 'Partita Iva')
  .set(NamespaceParamTypes.STRING, 'Testo')
  .set(NamespaceParamTypes.YEAR, 'Anno')
  .set(NamespaceParamTypes.URL, 'Indirizzo web')
  .set(NamespaceParamTypes.DATE, 'Data')
;
